import { z } from 'zod';

export type ChatAttachmentUploadProcess = {
  file: File,
  conversationId: string,
  startUploadData: {
    file_type: string,
    file_name: string,
    file_size: number,
  }
};

export type LogoBannerUploadProcess = {
  file: File,
  uploadType: 'logo' | 'banner',
  slug: string,
  selectedChannelId: number,
  startUploadData: {
    file_type: string,
    file_name: string,
  }
};

export type FileUploadProcess = {
  file: File,
  slug: string,
  startUploadData: {
    file_type: string,
    file_name: string,
    file_size: number,
    folder?: number,
  }
};

export type TenantLogoUploadProcess = {
  file: File,
  slug: string,
  startUploadData: {
    file_type: string,
    file_name: string,
  }
};

export type TenantInfographicUploadProcess = {
  file: File,
  slug: string,
  selectedChannelId: number,
  startUploadData: {
    file_type: string,
    file_name: string,
    is_display_on_program_overview_enabled: boolean,
  }
};

export type ReportingUploadProcess = {
  file: File,
  slug: string,
  startUploadData: {
    file_type: string,
    file_name: string,
  }
};

export const startResponseSchema = z.object({
  id: z.number().optional(),
  fields: z.record(z.string()),
  url: z.string(),
});
export type StartResponse = z.infer<typeof startResponseSchema>;